var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-button',{attrs:{"icon":_vm.icon,"disabled":_vm.loading,"is-loading":_vm.loading},on:{"click":_vm.downloadFile}},[_vm._t("default",[_vm._v(_vm._s(_vm.$t('download')))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }